export type OfficeFrameKind = 'docx' | 'pptx';

export const OFFICE_FRAME_CHANNEL = 'littlebird-office-frame';
export const OFFICE_FRAME_NONCE_GLOBAL = '__littlebirdOfficeFrameNonce';

export type OfficeFrameEvent =
  | { type: 'ready' }
  | { type: 'rendered' }
  | { type: 'error' }
  | { type: 'link'; href: string };

type OfficeFrameEnvelope = {
  channel?: unknown;
  nonce?: unknown;
  type?: unknown;
  href?: unknown;
  bytes?: unknown;
};

const readEnvelope = (
  data: unknown,
  nonce: string
): OfficeFrameEnvelope | null => {
  if (typeof data !== 'object' || data === null) return null;
  const envelope = data as OfficeFrameEnvelope;
  const isOwnFrame =
    envelope.channel === OFFICE_FRAME_CHANNEL && envelope.nonce === nonce;
  return isOwnFrame ? envelope : null;
};

export const parseOfficeFrameEvent = (
  data: unknown,
  nonce: string
): OfficeFrameEvent | null => {
  const envelope = readEnvelope(data, nonce);
  if (!envelope) return null;

  if (envelope.type === 'ready') return { type: 'ready' };
  if (envelope.type === 'rendered') return { type: 'rendered' };
  if (envelope.type === 'error') return { type: 'error' };
  if (envelope.type === 'link' && typeof envelope.href === 'string') {
    return { type: 'link', href: envelope.href };
  }
  return null;
};

const isArrayBuffer = (value: unknown): value is ArrayBuffer =>
  Object.prototype.toString.call(value) === '[object ArrayBuffer]';

export const parseOfficeFrameRenderRequest = (
  data: unknown,
  nonce: string
): ArrayBuffer | null => {
  const envelope = readEnvelope(data, nonce);
  if (!envelope || envelope.type !== 'render') return null;
  return isArrayBuffer(envelope.bytes) ? envelope.bytes : null;
};

export const officeFrameLinkHref = (
  target: EventTarget | null
): string | null => {
  const element = target as Element | null;
  if (!element || typeof element.closest !== 'function') return null;
  return element.closest('a[href]')?.getAttribute('href') ?? null;
};
